export default class GpecSynthesePrevisionnelDto {
  id;
  marche;
  trimestre;
  trimestresSuivants;
  postesByTrimestre = [];
  commentaire;
  statut;
  jourSoumissionPassed;
  user;
}
